<template>
  <div class="calendars-config-vue">
    <loader v-if="loading" />
    <div v-else class="col-12">
      <div v-if="!workHoursNotSet">
        <button v-for="tab in tabs" :key="tab"
          class="btn" 
          :class="activeTab === tab ? 'btn-primary dark' : 'btn-secondary'" 
          @click="activeTab = tab">

          {{ tab }}
        </button>
      </div>

      <div class="dashboard-card hard-angle">
        <div v-if="workHoursNotSet" class="work-hours-not-set">
          Your recurring hours have not yet been set. 
          To continue, please set them by clicking "Apply".
        </div>
        <work-hours 
          v-if="activeTab === 'Recurring Hours'"
          :counselorId="counselorId" 
          :displayCalendars="$store.getters.currentUser.isAdmin" 
          @work-hours-set="workHoursSetCallback"/>
        <additional-availability
          v-if="activeTab === 'Customize Availability'"
          :counselorId="counselorId" />
        <calendar-sync
          v-if="activeTab === 'Calendar Sync'"
          :counselorId="counselorId" 
          :redirectUri="redirectUri"
          @profile-revoked="activeTab = 'Recurring Hours'" />
      </div>
    </div>
  </div>
</template>

<script>
import CounselorClient from '@/api/CounselorClient';
import WorkHours from './components/WorkHours.vue';
import AdditionalAvailability from './components/AdditionalAvailability.vue';
import CalendarSync from './components/CalendarSync.vue';
import Loader from '@/components/Loader.vue'

export default {
  name: 'CalendarsConfig',
  components: {
    Loader,
    WorkHours,
    AdditionalAvailability,
    CalendarSync,
  },
  data(){
    return {
      counselorClient: new CounselorClient(this.$http),
      redirectUri: document.location.origin + this.$router.match({name: 'third-party-link-complete'}).fullPath,
      counselorId: 0,
      loading: true,
      activeTab: "Recurring Hours",
      tabs: [
        "Recurring Hours",
        "Customize Availability",
        "Calendar Sync",
      ]
    }
  },
  async created() {
    const { id } = this.$route.query;
    
    if(id && this.$store.getters.currentUser.isAdmin)
      this.counselorId = Number(id);
    else if(this.$store.getters.currentUser.isCounselor)
      this.counselorId = this.$store.getters.currentUser.counselor_profile.id;
    else 
      this.$router.push("dashboard");
  },
  computed: {
    workHoursNotSet() {
      return this.$store.getters.currentUser.isCounselor
        && !this.$store.getters.currentUser.counselor_profile.has_set_working_hours;
    }
  },
  async mounted() {
    if(this.$store.getters.currentUser.isCounselor) {
      await this.ensureBetterMyndCalendarCreated();
    }

    this.loading = false;
  },
  methods: {
    async ensureBetterMyndCalendarCreated() {
      if(!this.$store.getters.currentUser.counselor_profile.in_app_calendar_initialized) {
        try {
          await this.counselorClient.linkBetterMyndCalendar(this.counselorId);
          this.$store.getters.currentUser.counselor_profile.in_app_calendar_initialized = true;
        } catch(ex) {
          console.error(ex);
          this.$store.commit('setGlobalAlert', {
            msg: 'Failed linking to BetterMynd calendar. Please refresh the page. If the issue persists, please contact support.', 
            error: true,
          });
        }
      }
    },
    workHoursSetCallback(saved){
      if(this.$store.getters.currentUser.isCounselor) {
        this.counselorClient.updatedAvailability(this.counselorId);
        this.counselorClient.syncCalendar(this.counselorId);

        this.$store.getters.currentUser.counselor_profile.has_set_working_hours = true;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.calendars-config-vue {
  .work-hours-not-set {
    border: 1px solid $black;   
    margin: 3px;
    margin-bottom: 10px;
    background-color: $red;
    color: $black;
    padding: 3px;
    text-align: center;
    border-radius: 5px;
  }
  .btn-primary.dark {
    background-color: $dark-blue;
    border-color: $dark-blue;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    color:$white;
  }
  .btn-secondary:hover {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    color:$white;
  }
  .hard-angle {
    border-top-left-radius: 0px;
  }
}
</style>